import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Auth } from "aws-amplify";
import { PERMISSIONS } from "../../../shared/constants";
import { Client } from "../../api-client/api-client";
import { MY_PERMISSIONS, USERS_SELF } from "../../route/api.routes";
const config = {
  name: "auth",
};
export const fetchSelf: any = createAsyncThunk(
  `${config.name}/fetchSelf`,
  async () => {
    return await Client.get(USERS_SELF);
  }
);
export const fetchMyPermissions: any = createAsyncThunk(
  `${config.name}/fetchMyPermissions`,
  async () => {
    return await Client.get(MY_PERMISSIONS);
  }
);
export const authSlice = createSlice({
  name: "auth",
  initialState: {
    myPermissions: null,
    token: null,
    user: null as any,
    incentive_portal_manager_view: false as any,
    incentive_portal_admin_view: false as any,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.incentive_portal_manager_view = false;
      state.incentive_portal_admin_view = false;
      state.myPermissions = null;
      logOutProviders();
      localStorage.clear();
      window.location.reload();
    },
    setUser: (state: any, action: any) => {
      state.user = action.payload;
    },
    setToken: (state: any, action: any) => {
      state.token = action.payload;
      localStorage.setItem("token", action.payload);
    },
  },
  extraReducers(builder: any) {
    builder
      .addCase(fetchSelf.pending, (state: any) => {})
      .addCase(fetchSelf.fulfilled, (state: any, action: any) => {
        state.user = action.payload?.data?.data;
      })
      .addCase(fetchSelf.rejected, (state: any) => {
        state.user = null;
      })
      .addCase(fetchMyPermissions.pending, (state: any) => {})
      .addCase(fetchMyPermissions.fulfilled, (state: any, action: any) => {
        state.myPermissions = action.payload?.data?.data;
        if (
          state.myPermissions?.scope_values?.actions?.indexOf("employee_portal_module") !==
            -1 ||
          state.myPermissions?.scope_values?.actions?.indexOf(
            PERMISSIONS.MANAGER_VIEW
          ) !== -1
        ) {
          state.incentive_portal_manager_view = true;
        } else {
          state.incentive_portal_manager_view = false;
        }
        if (
          state.myPermissions?.scope_values?.actions?.indexOf("employee_portal_module") !==
            -1 ||
          state.myPermissions?.scope_values?.actions?.indexOf(
            PERMISSIONS.ADMIN_VIEW
          ) !== -1
        ) {
          state.incentive_portal_admin_view = true;
        } else {
          state.incentive_portal_admin_view = false;
        }
      })
      .addCase(fetchMyPermissions.rejected, (state: any) => {
        state.user = null;
      });
  },
});

export const { logout, setToken, setUser } = authSlice.actions;

export default authSlice.reducer;

export const logOutProviders = async () => {
  if (localStorage.getItem("auth-type")) {
    if (localStorage.getItem("auth-type") === "cognito") {
      try {
        await Auth.signOut();
      } catch (error) {
        console.log("error signing out: ", error);
      }
    }
    sessionStorage.clear();
  }
};
